export const FieldPickerPopUpContent = {
  attributes: {
    FieldPickerSearch: "field-picker-search",
    FieldPickerError: "field-picker-error"
  }
};
